import { MenuItem, TextField } from '@mui/material';
import { JobResultDisplayLabelOption } from 'interfaces/jobResultMetadata';
import React from 'react';
import { getJobResultSlideLabelOptionLabel } from 'utils/jobResultAugmentation';

interface Props {
  value: JobResultDisplayLabelOption;
  options: JobResultDisplayLabelOption[];
  onChange: (nextValue: JobResultDisplayLabelOption) => void;
}

const JobResultSlideLabelModeSelect: React.FC<Props> = ({ value, options, onChange }) => {
  return (
    <TextField
      select
      size="small"
      label="Slide labels"
      value={value}
      onChange={(event) => onChange(event.target.value as JobResultDisplayLabelOption)}
      sx={{ minWidth: 180, width: { xs: '100%', sm: 'auto' } }}
    >
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {getJobResultSlideLabelOptionLabel(option)}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default JobResultSlideLabelModeSelect;
